function calculatePercentage(number, maxValue) {
    if (!number || maxValue === 0) {
        return '0%';
    }
    const percentage = (number / maxValue) * 100;
    return percentage.toFixed(2) + '%';
}
export default calculatePercentage;